import { render, staticRenderFns } from "./widget-management.vue?vue&type=template&id=58fa0cd5&scoped=true&"
import script from "./widget-management.vue?vue&type=script&lang=js&"
export * from "./widget-management.vue?vue&type=script&lang=js&"
import style0 from "./widget-management.vue?vue&type=style&index=0&id=58fa0cd5&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fa0cd5",
  null
  
)

export default component.exports